import React from 'react'

import { Avatar as TideAvatar } from '@driftt/tide-core'

import { CompanyData } from 'modules/accountActivity/domain'

export const CompanyLogo = ({ company }: { company: CompanyData }) => {
  return <TideAvatar type="company" company={company} />
}

export default CompanyLogo
